/** @format */

import React, { Component } from 'react';
import { Menu, Button, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import './SaleToolbar.css';

@inject('UserStore', 'RequestsStore', 'ClientsStore', 'SalesStore')
@observer
class SaleToolbar extends Component {
  renderButton = () => {
    const { UserStore, SalesStore } = this.props;

    let renderButtons = [
      <Menu.Item key="viewRequest">
        <Button
          size="small"
          onClick={() => {
            this.props.history.push(
              '/requests/' + SalesStore.currentSale.data._requestId + '/view',
            );
          }}
          color="black"
        >
          Vedi richiesta Collegata
        </Button>
      </Menu.Item>,
    ];

    if (
      SalesStore.currentSale.data.status === 'new' &&
      UserStore.user.role === 'warehouse'
    ) {
      renderButtons.push(
        <Menu.Item key="manageSale">
          <Button
            size="small"
            onClick={() => {
              SalesStore.saleManaged();
            }}
            color="green"
          >
            <Icon name="check" />
            Vendita gestita
          </Button>
        </Menu.Item>,
      );
    }
    return renderButtons;
  };
  render() {
    const { SalesStore } = this.props;
    return (
      <Menu className="newEditRequest-toolbar" borderless size="small">
        <Menu.Menu position="right">
          <Menu.Item>
            <Button
              size="small"
              onClick={() => {
                SalesStore.resetCurrentSale();
                this.props.history.push('/sales');
              }}
              color="red"
            >
              <Icon name="arrow left" />
              Torna alle Vendite
            </Button>
          </Menu.Item>
          {this.renderButton()}
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(SaleToolbar);
